/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
export function BreadcrumbIcon() {
    return function (bLabel) {
        var labelObj = angular.fromJson(bLabel);
        if (angular.isDefined(labelObj.icon)) {
            return labelObj.icon;
        }
        return null;
    };
}

export function BreadcrumbSvgIcon() {
    return function (bLabel) {
        var labelObj = angular.fromJson(bLabel);
        if (angular.isDefined(labelObj.svgIcon)) {
            return labelObj.svgIcon;
        }
        return null;
    };
}



// WEBPACK FOOTER //
// ./src/app/layout/breadcrumb-icon.filter.js